import { IconButton, Stack, styled } from '@ethings/ui-toolkit';
import { Box, Dialog } from '@mui/material';
import { FC, type JSX } from 'react';
import { Icon } from '../icons';

interface Props {
  actions: JSX.Element[];
  closeDialog: () => void;
  'data-testid'?: string;
  eventData: JSX.Element;
  mediaComponent?: JSX.Element;
  open: boolean;
  pageTitle: JSX.Element;
}

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  marginLeft: theme.spacing(3),
}));

export const EventDialogDesktop: FC<Props> = ({
  actions,
  closeDialog,
  eventData,
  mediaComponent,
  open,
  pageTitle,
  ...props
}) => {
  return (
    <Dialog fullWidth maxWidth="md" data-testid={props['data-testid']} onClose={closeDialog} open={open}>
      <Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between" p={2}>
          {pageTitle}
          <Box flex={0} flexBasis="auto">
            {actions}
            <StyledIconButton data-testid="close-button" onClick={closeDialog}>
              <Icon data-testid="close-icon" icon="CloseIcon" />
            </StyledIconButton>
          </Box>
        </Stack>
        <Stack p={2} pt={1}>
          {eventData}
        </Stack>
        {mediaComponent}
      </Stack>
    </Dialog>
  );
};
